// extracted by mini-css-extract-plugin
export default {"rating":"My-z","numberOfStars":"Ny-z","count":"Oy-z","barGraphSpacing":"Py-z","barGraph":"Qy-z"};